var DualRowPackageWithJOrLLeadData = require('./dualRowPackageWithJOrLLeadData.js');
var lib_core = require("lib-core");

var OscillatorLBendData = function(position, angle, init) {
    DualRowPackageWithJOrLLeadData.apply(this, arguments);
};

lib_core.inherit(OscillatorLBendData, DualRowPackageWithJOrLLeadData);
lib_core.JsonParser.registerClass(OscillatorLBendData, "OscillatorLBendData");

module.exports = OscillatorLBendData;
